import { from } from 'rxjs';
import { AuthHttp } from '@common/services';

/**
 * GET /cost-centers?companyId=:id
 *
 * @param companyId
 */
export function getCostCentersAPI(companyId) {
  const url = `/cost-centers?companyId=${companyId}`;
  return from(AuthHttp.get(url));
}

/**
 * GET /companies
 *
 */
export function getCompanyOptionsAPI() {
  const url = '/companies';
  return from(AuthHttp.get(url));
}

/**
 * GET /business-units
 *
 */
export function getBUsAPI() {
  const url = '/business-units';
  return from(AuthHttp.get(url));
}

/**
 * GET /business-units/search-list
 *
 */
export function getBUListByCostCenterAPI(costCenterId) {
  const url = `/business-units/search-list?costCenterId=${costCenterId}`;
  return from(AuthHttp.get(url));
}

/**
 * GET /roles
 *
 */
export function getAllRoleAPI(buId) {
  let url = '/roles';
  if(buId)
  {
    url = `/roles?buId=${buId}`;
  }
  return from(AuthHttp.get(url));
}
